import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import { AppBundle } from 'api/optimalprint-sdk.d';
import getCategories from 'store/app/selector/getCategories';
import setPricesToFetchOperation from 'store/price/operation/setPricesToFetchOperation';
import findRootCategory from 'utils/category/findRootCategory';
import collectPricesFromSimilarProducts from 'utils/price/collectPricesFromSimilarProducts';
import getConfigurationByKey from 'store/app/selector/getConfigurationByKey';
import { HttpMethods } from 'api/types';
import { setProductRecommendationAction } from '../slice';
import { ProductRecommendationSlot } from '../types';
import { SetProductRecommendationPayload } from '../reducer/setProductRecommendationReducer';
import getCommonProductRequestParams from '../selector/getCommonProductRequestParams';

/**
 * Sub category ID should be present if it's popular in the same category request
 * @returns Promise
 */
const fetchProductRecommendationOperation =
  (slotName: string, productRecommendationStoreSlot: ProductRecommendationSlot, passSubcategoryId?: boolean) =>
  async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const { categoryId: subCategoryId, encPublicDesignId, locale } = getCommonProductRequestParams(store);
    const categories = getCategories(store);
    const rootCategory = findRootCategory(subCategoryId || 1, categories);
    const slotNameConfiguration = getConfigurationByKey(slotName)(store);

    const recommendationRequest: Partial<AppBundle.Api.Request.Recommendation.V1.RecommendationListV1Request> = {
      isMobile: false,
      categoryId: rootCategory?.categoryId,
      locale,
      encDesignId: encPublicDesignId || '',
      slotName: slotNameConfiguration || '',
    };

    if (passSubcategoryId) {
      recommendationRequest.subCategoryId = Number(subCategoryId);
    }

    const recommendedProductsData = (await apiRequest(
      endpoints.recommendation,
      recommendationRequest,
      HttpMethods.POST,
      'data',
    )) as AppBundle.Api.Response.Recommendation.V1.RecommendationListV1Response;

    const prices = collectPricesFromSimilarProducts(recommendedProductsData.items || []);
    dispatch(setPricesToFetchOperation(prices));

    const productRecommendationActionPayload: SetProductRecommendationPayload = {
      productRecommendationStoreSlot,
      products: recommendedProductsData.items,
      slotName: recommendedProductsData.slot,
      rootCategoryId: rootCategory?.categoryId,
    };

    dispatch(setProductRecommendationAction(productRecommendationActionPayload));
  };

export default fetchProductRecommendationOperation;
